import { render, staticRenderFns } from "./View5.vue?vue&type=template&id=5d6d30d2"
import script from "./View5.vue?vue&type=script&lang=js"
export * from "./View5.vue?vue&type=script&lang=js"
import style0 from "./View5.vue?vue&type=style&index=0&id=5d6d30d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports